import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/runner/work/app/app/layouts/admin.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/home/runner/work/app/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/app/app/layouts/default.vue").then(m => m.default || m)),
  "lab-portal": defineAsyncComponent(() => import("/home/runner/work/app/app/layouts/lab-portal.vue").then(m => m.default || m))
}